import script from "./CollapseItem.vue?vue&type=script&setup=true&lang=js"
export * from "./CollapseItem.vue?vue&type=script&setup=true&lang=js"

import "./CollapseItem.vue?vue&type=style&index=0&id=509ddd98&lang=scss"

const __exports__ = script;

export default __exports__